"use client";

import Image from "next/image";
import styles from "@/app/styles/whyChooseUs.module.scss";
import whyChooseUsData from "@/data/whyChooseUsData";
import { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SectionWhyChooseUs = () => {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);
  const itemsRef = useRef([]);

  useGSAP(
    () => {
      gsap.fromTo(
        headerRef.current,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1.5,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
      itemsRef.current.forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, y: 100 }, // เริ่มต้น animation
          {
            opacity: 1,
            y: 0, // จุดสิ้นสุด animation
            duration: 1, // ระยะเวลา
            scrollTrigger: {
              trigger: el, // อ้างอิง section นี้
              start: "top 60%", // เริ่มเมื่อ section เข้าสู่ viewport 80%
              end: "bottom 20%", // สิ้นสุดเมื่อออกจาก viewport 20%
              toggleActions: "play none none none", // ควบคุม animation: play ครั้งเดียว
            },
          }
        );
      });
    },
    { scope: sectionRef }
  );
  return (
    <section className={styles.whyChooseUs} ref={sectionRef}>
      <div className={styles.headerContainer} ref={headerRef}>
        <h1 className={`header mb-8`}>
          <div>Crafted with Care, Inspired by Nature</div>
        </h1>
        <p className="font-[500] text-[24px] text-center mb-6">
          กลมกลืนกับธรรมชาติ เติมเต็มด้วยหัวใจ
        </p>
      </div>

      <div className={styles.contentContainer}>
        {whyChooseUsData.map((item, index) => (
          <div
            key={index + 1}
            className={(index + 1) % 2 === 0 ? styles.rowReverse : styles.row}
          >
            <Image
              src={item.img}
              fill
              quality={90}
              priority
              alt={item.title || "Why choose us image"}
              onContextMenu={(e) => e.preventDefault()}
            />
            <div ref={(el) => (itemsRef.current[index + 1] = el)} className={styles.textContainer}>
              <div className={styles.textContent}>
                <h3>{item.title}</h3>
                <h4>{item.subtitle}</h4>
                <p>{item.description}</p>
              </div>
              {/* <span>{item.text}</span> */}
            </div>
          </div>
        ))}
      </div>
      {/* <div className={styles.ctaContainer}>
        <p>ให้ Cozyscape สร้างพื้นที่ที่เชื่อมโยงธรรมชาติและตัวตนของคุณ</p>
      </div> */}
    </section>
  );
};

export default SectionWhyChooseUs;
